import Reveal from "../Reveal";
import LeadForm from "../LeadForm";
import { COMPANY } from "../../lib/site";
import { Phone, Mail } from "lucide-react";

export default function LeadSection({ sourcePage = "Homepage", defaultCity = "", title }) {
  return (
    <section id="quote" data-testid="lead-section" className="bg-forest py-24 text-cream md:py-32">
      <div className="mx-auto grid max-w-[1400px] gap-14 px-6 md:px-12 lg:grid-cols-[0.8fr_1.2fr]">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-gold">Free assessment</p>
          <h2 className="mt-4 font-heading text-4xl font-extrabold leading-[1] tracking-tight md:text-5xl">
            {title || "Get your free rooftop solar quote."}
          </h2>
          <p className="mt-5 max-w-sm leading-relaxed text-cream/70">
            Share a few details and a Synergy Solar advisor will call you within one business day with a tailored, no-obligation proposal.
          </p>
          <div className="mt-10 space-y-4">
            <a href={COMPANY.phoneHref} className="flex items-center gap-3 text-cream/90 transition-colors hover:text-gold">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10"><Phone className="h-5 w-5" /></span>
              <span><span className="block text-xs uppercase tracking-widest text-cream/50">Call us</span>{COMPANY.phone}</span>
            </a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 text-cream/90 transition-colors hover:text-gold">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10"><Mail className="h-5 w-5" /></span>
              <span><span className="block text-xs uppercase tracking-widest text-cream/50">Email</span>{COMPANY.email}</span>
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="rounded-[2rem] border border-white/10 bg-white/5 p-8 backdrop-blur-xl md:p-10">
            <LeadForm sourcePage={sourcePage} defaultCity={defaultCity} dark />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
